import type { InputHTMLAttributes } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/**
 * Interrupteur style iOS — piste + pastille glissante, `role="switch"`
 * natif via `<input type="checkbox">`. Contrairement à une paire de boutons
 * segmentés (`ds-theme-toggle`, pensée pour 3 choix nommés), l'état
 * on/off se lit d'un coup d'œil à la position/couleur, sans lire le texte.
 */
export function Switch({ checked, onCheckedChange, className, disabled, ...props }: SwitchProps) {
  return (
    <label className={mergeClassNames('ds-switch', disabled ? 'ds-switch--disabled' : undefined, className)}>
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          onCheckedChange(event.target.checked)
        }}
        {...props}
      />
      <span className="ds-switch__track" aria-hidden="true">
        <span className="ds-switch__thumb" />
      </span>
    </label>
  )
}
